import { observer } from 'mobx-react-lite'
import React from 'react'
import { Typography, Tooltip, ButtonCopy } from 'shared/ui'
import { makeTextFieldElement, TextFieldPlaceholder } from 'shared/ui/TextField'
import { useReferralsViewContext } from 'pages/settings/pages/referrals/context/referralsViewContext'
import { ReferralsLink } from 'pages/settings/pages/referrals/pages/ReferralsView/ui/ReferralsLinks/ReferralsLink'
import styles from './styles.module.scss'

const SOCIAL_MEDIA_CONFIG = [
  {
    icon: 'facebook' as const,
    linkKey: 'facebookLink',
    ariaLabel: 'ReferralsLinks_Facebook',
    className: styles.facebook,
  },
  {
    icon: 'twitter' as const,
    linkKey: 'twitterLink',
    ariaLabel: 'ReferralsLinks_Twitter',
    className: styles.twitter,
  },
  {
    icon: 'linkedin' as const,
    linkKey: 'linkedinLink',
    ariaLabel: 'ReferralsLinks_Linkedin',
    className: styles.linkedin,
  },
] as const

export const ReferralsLinks = observer(() => {
  const { referralsInfo } = useReferralsViewContext()

  return (
    <div className={styles.container}>
      <div className={styles.description}>
        <Typography
          variant='body-md-medium'
          color='var(--content-primary-primary)'
          ariaLabel='ReferralsLinks_title'
          marginBottom={4}
        >
          Invite via link
        </Typography>
        <Typography
          variant='body-md-regular'
          color='var(--content-primary-tertiary)'
          ariaLabel='ReferralsLinks_desc'
        >
          Copy and share this url with your friends
        </Typography>
      </div>
      <TextFieldPlaceholder
        className={styles.linkField}
        size='medium'
        variant='stroke'
        placeholder={
          <Tooltip placement='top' label={referralsInfo?.referralLink} fullWidth>
            <Typography
              tag='div'
              ariaLabel='ReferralsLinks_Url'
              variant='text-input-field'
              color='var(--content-primary-primary)'
              ellipsis
            >
              {referralsInfo?.referralLink}
            </Typography>
          </Tooltip>
        }
        rightActions={[
          makeTextFieldElement({
            element: (
              <ButtonCopy value={referralsInfo?.referralLink ?? ''} buttonProps={{ tag: 'div' }} />
            ),
          }),
        ]}
      />
      <div className={styles.socials}>
        {SOCIAL_MEDIA_CONFIG.map(({ icon, linkKey, ariaLabel, className }) => {
          const link = referralsInfo?.[linkKey] ?? ''
          return (
            <ReferralsLink
              key={icon}
              icon={icon}
              ariaLabel={ariaLabel}
              className={className}
              link={link}
            />
          )
        })}
      </div>
    </div>
  )
})
